<div class="container auth" [zeroLoadingIndicator]="ongoingRequest">
  <div class="row mt-5">
    <div class="col-12">
      <div class="mt-5 mb-5">
        <svg width="204" height="66" viewBox="0 0 204 66" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="5.225%" y1="30.006%" x2="26.572%" y2="86.613%" id="zdgy2isy8a">
              <stop stop-color="#E81673" offset="0%" />
              <stop stop-color="#2C8BF1" offset="100%" />
            </linearGradient>
          </defs>
          <g fill-rule="nonzero" fill="none">
            <path
              d="M65.951 20.722v-5.814A14.932 14.932 0 0 0 61.583 4.37 14.907 14.907 0 0 0 51.055 0H14.896A14.908 14.908 0 0 0 4.368 4.371 14.931 14.931 0 0 0 0 14.908v20.78l7.292-3.616V14.908a7.62 7.62 0 0 1 7.604-7.61h36.159a7.608 7.608 0 0 1 5.374 2.232 7.62 7.62 0 0 1 2.229 5.378v1.285L0 45.279v5.813A14.93 14.93 0 0 0 4.367 61.63 14.909 14.909 0 0 0 14.897 66h36.158a14.907 14.907 0 0 0 10.528-4.371 14.93 14.93 0 0 0 4.368-10.537V30.32l-7.293 3.616v17.163a7.62 7.62 0 0 1-2.23 5.378 7.609 7.609 0 0 1-5.373 2.232H14.896a7.611 7.611 0 0 1-5.374-2.232 7.62 7.62 0 0 1-2.23-5.378v-1.284l58.66-29.092z"
              fill="url(#zdgy2isy8a)"
            />
            <path
              fill="#FFF"
              d="m85.304 57.637 20.016-24.594 3.54-3.952-5.379.068H85.1v-2.93h27.572v2.658L93.27 52.868l-4.084 4.565 6.127-.068h18.177v2.93H85.304zM146.586 42.445c0 .772-.045 1.521-.136 2.248h-27.028c.227 4.178 1.452 7.449 3.676 9.81 2.27 2.317 5.288 3.475 9.055 3.475 2.678 0 4.97-.545 6.876-1.635 1.952-1.09 3.359-2.634 4.22-4.633l2.86 1.499c-1.27 2.498-3.086 4.428-5.446 5.79-2.36 1.318-5.197 1.977-8.51 1.977-5.038 0-8.987-1.567-11.846-4.701-2.814-3.134-4.221-7.472-4.221-13.013 0-5.541 1.361-9.879 4.085-13.013 2.768-3.134 6.626-4.7 11.573-4.7 4.63 0 8.26 1.544 10.893 4.632 2.633 3.089 3.949 7.177 3.949 12.264zm-14.842-13.899c-3.676 0-6.58 1.158-8.714 3.475-2.133 2.27-3.336 5.473-3.608 9.606h23.964c-.227-4.088-1.362-7.29-3.404-9.606-1.997-2.317-4.743-3.475-8.238-3.475zM167.187 25.548c1.815 0 3.245.386 4.289 1.159l-.885 3.202c-1.044-.818-2.497-1.227-4.358-1.227-1.724 0-3.358.545-4.901 1.636-1.498 1.044-2.724 2.543-3.677 4.496-.907 1.908-1.361 4.042-1.361 6.404v19.076h-3.404V26.23h2.86l.408 6.949c.953-2.407 2.36-4.27 4.22-5.587 1.907-1.362 4.176-2.044 6.809-2.044zM187.578 25.548c5.038 0 8.986 1.59 11.846 4.77 2.904 3.133 4.357 7.448 4.357 12.944s-1.453 9.833-4.357 13.013c-2.86 3.134-6.808 4.7-11.846 4.7s-9.01-1.566-11.914-4.7c-2.86-3.18-4.29-7.517-4.29-13.013 0-5.496 1.43-9.81 4.29-12.944 2.904-3.18 6.876-4.77 11.914-4.77zm0 2.93c-3.994 0-7.126 1.317-9.395 3.952-2.27 2.634-3.404 6.245-3.404 10.832 0 4.588 1.134 8.198 3.404 10.833 2.27 2.634 5.4 3.951 9.395 3.951 3.994 0 7.125-1.317 9.395-3.951 2.27-2.635 3.404-6.245 3.404-10.833 0-4.587-1.135-8.198-3.404-10.832-2.27-2.635-5.401-3.952-9.395-3.952zM86.808 6.21v4.494h5.584v.829h-5.584v5.5h-.88V5.398h7.926v.81zM96.918 17.032h-.88V5.4h.88zM109.333 17.032h-1.092l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.845V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM119.265 13.384h-5.566l-1.445 3.648h-.933L115.97 5.4h1.039l4.65 11.633h-.933l-1.462-3.648zm-.317-.811-2.026-5.077-.423-1.234h-.017l-.423 1.199-2.026 5.112h4.915zM132.58 17.032h-1.091l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.845V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM143.975 16.221v.811h-8.984v-.775l7.663-10.048h-7.504V5.4h8.543v.775l-7.662 10.047zM154.557 16.221v.811h-8.226V5.4h7.944v.81h-7.063v4.495h5.583v.829h-5.583v4.688zM165.87 17.032h-1.092l-6.165-9.13-.863-1.552h-.017l.053 1.463v9.22h-.846V5.398h1.11l6.147 9.113.88 1.568-.035-1.463V5.4h.828zM169.46 15.587a.73.73 0 0 1 .564.23.73.73 0 0 1 .23.563.788.788 0 0 1-.23.582c-.14.14-.328.211-.563.211a.823.823 0 0 1-.581-.211.824.824 0 0 1-.212-.582c0-.235.07-.423.212-.564a.787.787 0 0 1 .58-.23zM181.98 17.032h-1.092l-6.165-9.13-.863-1.552h-.018l.053 1.463v9.22h-.846V5.398h1.11l6.147 9.113.881 1.568-.035-1.463V5.4h.828zM193.69 16.221v.811h-8.225V5.4h7.944v.81h-7.064v4.495h5.584v.829h-5.584v4.688zM204 6.21h-4.245v10.822h-.88V6.21h-4.246V5.4H204z"
            />
          </g>
        </svg>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-6">
      <!-- Layout for fz default and any generic origin request client -->
      @if (originClient === ORIGIN_CLIENT_GENERIC) {
        <h1 class="font-light mb-4">{{ 'login.default.greeting' | transloco }}</h1>
      }

      <!-- Layout for TradingView origin -->
      @if (originClient === ORIGIN_CLIENT_TRADINGVIEW) {
        <div class="d-flex flex-row">
          <div>
            <h1 class="font-light mb-4">{{ 'login.tradingView.greeting' | transloco }}</h1>
          </div>
          <div>
            <h1 class="font-light mb-4">
              <svg class="hidden-xs ml-2 mr-1" width="36" height="28" viewBox="0 1 36 28" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 22H7V11H0V4h14v18zM28 22h-8l7.5-18h8L28 22z" fill="currentColor" />
                <circle cx="20" cy="8" r="4" fill="currentColor" />
              </svg>
              <svg class="ml-2" width="147" height="28" viewBox="0 1 147 28" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.793 22.024h3.702V7.519h4.843V4.02H0v3.5h4.793v14.504zM13.343 22.024h3.474v-6.06c0-2.105 1.09-3.373 2.74-3.373.582 0 1.039.101 1.571.279V9.345a3.886 3.886 0 00-1.166-.152c-1.42 0-2.713.938-3.145 2.18V9.346h-3.474v12.679zM27.796 22.303c1.75 0 3.068-.888 3.652-1.7v1.42h3.474V9.346h-3.474v1.42c-.584-.811-1.902-1.699-3.652-1.699-3.372 0-5.959 3.043-5.959 6.618 0 3.576 2.587 6.619 5.96 6.619zm.736-3.17c-1.928 0-3.196-1.445-3.196-3.448 0-2.004 1.268-3.45 3.196-3.45 1.927 0 3.195 1.446 3.195 3.45 0 2.003-1.268 3.448-3.195 3.448zM43.193 22.303c1.75 0 3.068-.888 3.651-1.7v1.42h3.474V3.007h-3.474v7.76c-.583-.812-1.901-1.7-3.651-1.7-3.373 0-5.96 3.043-5.96 6.618 0 3.576 2.587 6.619 5.96 6.619zm.735-3.17c-1.927 0-3.195-1.445-3.195-3.448 0-2.004 1.268-3.45 3.195-3.45 1.927 0 3.195 1.446 3.195 3.45 0 2.003-1.268 3.448-3.195 3.448zM55.166 7.412a2.213 2.213 0 002.232-2.206A2.213 2.213 0 0055.166 3a2.224 2.224 0 00-2.206 2.206 2.224 2.224 0 002.206 2.206zm-1.724 14.612h3.474V9.49h-3.474v12.533zM59.998 22.024h3.474v-6.187c0-2.435 1.192-3.601 2.815-3.601 1.445 0 2.232 1.116 2.232 2.941v6.847h3.474v-7.43c0-3.296-1.826-5.528-4.894-5.528-1.649 0-2.942.71-3.627 1.724V9.345h-3.474v12.679zM80.833 18.65c-1.75 0-3.22-1.319-3.22-3.246 0-1.952 1.47-3.246 3.22-3.246 1.75 0 3.22 1.294 3.22 3.246 0 1.927-1.47 3.246-3.22 3.246zm-.406 8.85c3.88 0 6.822-1.978 6.822-6.543V9.268h-3.474v1.42C83.09 9.7 81.72 8.99 80.098 8.99c-3.322 0-5.985 2.84-5.985 6.415 0 3.55 2.663 6.39 5.985 6.39 1.623 0 2.992-.735 3.677-1.673v.862c0 2.029-1.344 3.474-3.398 3.474-1.42 0-2.84-.482-3.956-1.572l-1.902 2.586c1.445 1.395 3.702 2.029 5.908 2.029zM94.594 22.024h3.27L105.32 4.02h-4.057l-5.021 12.501L91.145 4.02h-3.981l7.43 18.004zM108.508 7.266a2.213 2.213 0 002.231-2.206 2.213 2.213 0 00-2.231-2.206c-1.192 0-2.207.988-2.207 2.206 0 1.217 1.015 2.206 2.207 2.206zm-1.725 14.758h3.474V9.345h-3.474v12.679zM119.248 22.303c2.662 0 4.691-1.116 5.883-2.84l-2.587-1.927c-.583.887-1.673 1.597-3.271 1.597-1.673 0-3.169-.938-3.372-2.637h9.483c.076-.533.051-.888.051-1.192 0-4.133-2.916-6.238-6.238-6.238-3.854 0-6.669 2.865-6.669 6.618 0 4.007 2.942 6.619 6.72 6.619zm-3.221-8.165c.33-1.547 1.775-2.207 3.069-2.207 1.293 0 2.561.685 2.865 2.207h-5.934zM138.45 22.024h3.449l4.184-12.679h-3.728l-2.383 8.114-2.587-8.114h-2.662l-2.561 8.114-2.409-8.114h-3.703l4.21 12.679h3.448l2.359-7.202 2.383 7.202z"
                  fill="currentColor"
                />
              </svg>
            </h1>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-lg-11">
            <div class="alert alert-danger show">
              <h5 class="mt-1 mb-3">{{ 'login.tradingView.alert.headline' | transloco }}</h5>
              <div [innerHTML]="'login.tradingView.alert.text' | transloco"></div>
            </div>
          </div>
        </div>
      }

      <div>
        @if (!authenticationData) {
          <form novalidate (ngSubmit)="login()" #loginForm="ngForm" autocomplete="off">
            <div class="row">
              <div class="col-lg-11 mb-3">
                <div class="input-group-material main-font-family">
                  <input
                    spellcheck="false"
                    id="userNameId"
                    type="text"
                    data-zid="usr"
                    [placeholder]="'login.default.usernamePlaceholder' | transloco"
                    required
                    [(ngModel)]="username"
                    name="userName"
                    #userNameVar="ngModel"
                    autocomplete="off"
                    [class.empty]="!userNameVar.value"
                  />
                  <div class="input-group-material-icon-state"></div>
                  @if ((userNameVar.errors && userNameVar.errors['required']) || userNameVar.valid) {
                    <div class="input-group-material-message">&nbsp;</div>
                  }
                  @if (
                    userNameVar.errors &&
                    userNameVar.errors['emailOrUser'] &&
                    userNameVar.invalid &&
                    ((userNameVar.touched && userNameVar.dirty) || validatedAtLeastOnce)
                  ) {
                    <div class="input-group-material-message">
                      {{ 'login.default.error.frontendValidationUsername' | transloco }}
                    </div>
                  }
                </div>
              </div>
              <div class="col-lg-11 mb-3">
                <div class="input-group-material">
                  <input
                    id="passwordId"
                    type="password"
                    required="required"
                    [placeholder]="'login.default.passwordPlaceholder' | transloco"
                    [(ngModel)]="password"
                    name="password"
                    data-zid="pass"
                    #passwordVar="ngModel"
                    [pattern]="validatedAtLeastOnce || passwordVar.touched ? passwordPattern : undefined"
                    autocomplete="off"
                    [class.empty]="!passwordVar.value"
                  />
                  <div class="input-group-material-icon-state"></div>
                  @if ((passwordVar.errors && passwordVar.errors['required']) || passwordVar.valid) {
                    <div class="input-group-material-message">&nbsp;</div>
                  }
                  @if (
                    passwordVar.errors &&
                    passwordVar.errors['pattern'] &&
                    passwordVar.invalid &&
                    ((passwordVar.touched && passwordVar.dirty) || validatedAtLeastOnce)
                  ) {
                    <div
                      class="input-group-material-message"
                      [innerHTML]="'login.default.error.frontendValidationPassword' | transloco"
                    ></div>
                  }
                  @if (backendError) {
                    {{ backendError }}
                  }
                </div>
              </div>
              <div class="col-lg-11">
                <div class="row align-items-center">
                  <div class="col-12 mb-4">
                    <web-design-system-button
                      [isSubmit]="true"
                      type="gold"
                      [fullwidth]="true"
                      data-zid="login"
                      [disabled]="!hasInitialized"
                    >
                      {{ 'login.default.submit' | transloco }}
                    </web-design-system-button>
                  </div>
                  <div class="col-sm-5 col-md-12 col-xl-5">
                    <a [routerLink]="commonRoutes.prelogin.forgot_pwd"> {{ 'login.default.forgotPassword' | transloco }} </a>
                  </div>
                  <div class="col-sm-7 col-md-12 col-xl-7 text-sm-right text-md-left text-xl-right">
                    {{ 'login.default.registerPrefix' | transloco }}
                    <a [routerLink]="commonRoutes.prelogin.register" data-zid="become-customer">
                      {{ 'login.default.register' | transloco }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        }
      </div>

      @if (authenticationData) {
        <div class="col-12 mb-4">
          <login-oauth-components-trading-session
            [verifyIsSessionAuthorized]="false"
            [dataToAuthorize]="authenticationData"
            (authorizationState)="sessionAuthState($event)"
          />
        </div>
      }

      <div class="row mt-3">
        <div class="col-12" data-nosnippet>
          <web-components-user-notes target="loginpage" wrapperDivClasses="mt-2 mb-5" />

          <div class="mt-4 mb-5">
            <h5 class="font-size-smaller1 font-medium">{{ 'login.default.securityInfo.header' | transloco }}</h5>
            <p class="font-size-smaller1 mt-2">
              {{ 'login.default.securityInfo.message1' | transloco }}
              <br />
              {{ 'login.default.securityInfo.message2' | transloco }}
              <a
                href="https://www.finanzen.net/zero/sicherheitshinweise/"
                target="_blank"
                rel="noopener noreferrer"
                class="link link-underline"
                >{{ 'login.default.securityInfo.message2LinkTitle' | transloco }}</a
              >{{ 'login.default.securityInfo.message3' | transloco }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Layout for fz default and any generic origin request client -->
    @if (originClient === ORIGIN_CLIENT_GENERIC) {
      <div class="col-lg-6 d-lg-flex align-items-start justify-content-end">
        <web-components-login-info-cards />
      </div>
    }

    <!-- Layout for TradingView origin -->
    @if (originClient === ORIGIN_CLIENT_TRADINGVIEW) {
      <div class="col-lg-6 d-lg-flex align-items-start justify-content-end">
        <div>
          <div class="variant-1 mt-4 mt-lg-0 mb-4 d-flex align-items-center hidden-xs hidden-sm hidden-md">
            <img src="assets/img/partner-integrations/tradingview/zero-lp-tradingview.png" alt="" class="partner-tv-logo" />
          </div>
        </div>
      </div>
    }
  </div>
</div>
